export default {
  link: {
    info_card: {
      title: 'احصل على عمولة متكررة مدى الحياة بنسبة 20% مقابل كل اشتراك شهري يدفعه المستخدمون الذين أحالتهم! لا يوجد حد!',
      description: '<p>شارك رابط الإحالة الخاص بك مع أصدقائك ومجتمعك، واكسب عمولة 20% عن كل خطة اشتراك يدفعها المستخدمون الذين تحضرهم إلى متجر MAXCOM.</br>' + 'عندما يشترك المستخدمون الذين أحلتهم إلى خطة مدفوعة، ستربح عمولة بنسبة 20% عن كل شهر يظلون فيه مشتركين. وحتى إذا بدأوا بالخطة المجانية، فستظل تحصل على عمولة بنسبة 20% عند ترقيتهم إلى خطة مدفوعة. </br>' + 'ابدأ الآن وشاهد عمولاتك تنمو شهرًا بعد شهر.</p>',
      copy_link_text: 'انسخ رابط الإحالة الخاص بك:',
      tracking_code_text: 'يمكنك أيضًا إضافة رموز التتبع الخاصة بك على النحو التالي:',
      tracking_info_alert: '<span>{referral_link}<span>?fbp=<span style="color: black">MyFacebookPixelHere</span>&tkp=<span style="color: black">MyTiktokPixelHere</span></span></span>'
    },
    filter: {
      search: {
        placeholder: 'البجث في المستخدمين'
      },
      status: {
        placeholder: 'جميع الحالات'
      },
      role: {
        placeholder: 'جميع الأدوار'
      },
      country: {
        placeholder: 'جميع البلدان'
      },
      referrer: {
        placeholder: 'جميع المحيلين'
      },
      sort: {
        new_to_old: 'من الجديد إلى القديم',
        old_to_new: 'من القديم إلى الجديد'
      }
    },
    table_card: {
      table: {
        sign_up_date: 'تاريخ التسجيل',
        referrer: 'المُحيل',
        role: 'دور',
        user_name: 'اسم المستخدم',
        full_name: 'الاسم الكامل',
        contact_details: 'تفاصيل الاتصال',
        country: 'دولة',
        subscription_plan: 'خطة الاشتراك',
        assigned_manager: 'المدير المعين',
        commission: 'العمولة'
      }
    }
  },
  invoices: {
    info_card: {
      title: 'فواتير الإحالة',
      description: 'عندما يقوم المستخدمون المحالون إليك بالاشتراك في خطة مدفوعة، سنعرض لك هنا فواتيرهم والعمولة التي حصلت عليها من خطتهم المشتركة (20% من كل فاتورة مدفوعة).</br>' + 'لتوليد فاتورة إحالة وطلب الدفع، يجب أن يكون لديك إجمالي عمولات متراكمة بقيمة 50 دولارًا أو أكثر من عمولات الإحالات الخاصة بك.</br>' + 'كل يوم اثنين سوف نقوم بمعالجة المدفوعات الخاصة بالفواتير التي قمت بإنشائها.'
    },
    filter: {
      referrer: {
        title: 'جميع المحيلين'
      },
      generated_for: {
        title: 'جميع اللدين تم الإنشاء من أجلهم'
      }
    },
    table_card: {
      description: 'هنا سوف ترى قائمة العمولات التي حصلت عليها من المستخدمين المحالين إليك </br>' + '(سنعرض هنا فقط قائمة الفواتير التي تمت تصفيتها حسب المستخدم الذي أحالها، وحسب حالة الفاتورة "مدفوعة")',
      total_commission: 'مجموع العمولة المختارة: $ {total}',
      buttons: {
        generate_payout: 'إنشاء الدفعة'
      },
      table: {
        invoice_id: 'معرف الفاتورة',
        created_at: 'تم إنشاؤه في',
        referrer: 'المُحيل',
        generated_for: 'تم إنشاؤه من أجل',
        subscription_amount: 'مبلغ الاشتراك',
        referral_commission: 'لجنة الإحالة'
      }
    }
  },
  payouts: {
    filter: {
      generated_for: {
        title: 'جميع المستخدمين اللذين تم الإنشاء من أجلهم'
      },
      payment_status: {
        title: 'جميع الحالات'
      }
    },
    payment_info: {
      title: 'معلومات الدفع'
    },
    stats: {
      title: 'إجمالي الأرباح المدفوعة',
      dates: {
        this_month: 'هذا الشهر',
        last_month: 'الشهر الماضي',
        this_year: 'هذا العام',
        last_year: 'العام الماضي'
      }
    },
    dialogs: {
      delete_confirmation: {
        title: 'حذف الفاتورة',
        content: 'هل أنت متأكد أنك تريد حذف هذه الفاتورة؟'
      }
    },
    info_card: {
      title: 'مدفوعات الإحالة',
      description: 'ستشاهد هنا جميع طلبات الدفع الخاصة بك لعمولات الإحالات التي تم إنشاؤها لك.</br>' + 'للحصول على الدفعة، يجب عليك إضافة طريقة الدفع المفضلة لديك، ويجب عليك أيضًا تجميع ما مجموعه 50 دولارًا أمريكيًا أو أكثر من عمولات الإحالات الخاصة بك.</br>' + 'كل يوم اثنين سوف نقوم بمعالجة المدفوعات الخاصة بالفواتير التي قمت بإنشائها.'
    },
    table_card: {
      buttons: {
        pay_invoices: {
          pre_text: 'قمت بوضع علامة على {count} فاتورة كمدفوعة',
          text: 'دفع الفواتير'
        }
      },
      table: {
        invoice_id: 'معرف الفاتورة',
        generated_by: 'تم إنشاؤه من طرف',
        created_at: 'التاريخ',
        generated_for: 'تم إنشاؤه من أجل',
        total_commission: 'مجموع العمولة',
        payment_method: {
          title: 'طريقة الدفع',
          placeholder: 'اختر طريقة الدفع',
          pending: 'في الإنتظار...'
        },
        invoice_type: 'نوع الفاتورة',
        status: 'الحالة',
        payment_id: 'معرف الدفع',
        actions: 'الإجراءات'
      }
    }
  }
};